<div class="container">
  <div class="submenu__container" [ngClass]="{ 'horiz-scroll': isHorizScroll }">
    @for (item of items; track item) {
      @if (item.url !== '' && item.url !== 'noroute') {
        <div>
          <a class="submenu__item" [routerLink]="item.url">
            <div class="submenu__image" aria-hidden="true" tabindex="-1">
              <img width="160" height="160" [ngSrc]="item.image" [alt]="item.name" [loaderParams]="{ builder: true }" />
            </div>
            <div class="submenu__title">
              <span [innerHTML]="item.name"></span>
            </div>
          </a>
        </div>
      }
    }
  </div>
</div>
